import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { SettingsBox } from './settings-box.model';
import * as moment from 'moment';
import { VwdOption } from '@vwd/vwd-pilldown';
import { Subject } from 'rxjs';
import { PrimeNgLocaleData } from '@vwd/ngx-i18n/primeng';
import { FormattingService } from '@vwd/ngx-i18n';
import { SettingsBoxService } from './settings-box.service';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
 
@Component({
  selector: 'settings-box',
  templateUrl: './settings-box.component.html',
  styleUrls: ['./settings-box.component.scss'],
  providers: [SettingsBoxService],
  encapsulation: ViewEncapsulation.None
})
export class SettingsBoxComponent implements OnInit, OnDestroy {

  frequenciesOpt: VwdOption[];

  calcMethodOpt: VwdOption[];

  dayConventionOpt: VwdOption[];

  lastCouponDateopt: VwdOption[] = [];

  twoButActive: boolean;

  threeButActive: boolean;

  firstCouponError: boolean;

  errorMessage: string;

  readonly today: Date = new Date();

  private ngUnsubscribe = new Subject();

  // tslint:disable-next-line:variable-name
  private _settingsOpt: SettingsBox;

  @Output() optChanged = new EventEmitter<SettingsBox>();

  @Output() handleError = new EventEmitter<boolean>();

  constructor(
    private formattingService: FormattingService,
    public localeData: PrimeNgLocaleData,
    private settingsService: SettingsBoxService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.settingsService.getFrequenciesOptOptions()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: VwdOption[]) => {
        this.frequenciesOpt = result;
      }, (e: Error) => {
        console.error('Bond - Calcualtor - Widget - SettingsBox - getFrequenciesOptOptions', e);
      });

    this.settingsService.getBondCalculationMethodeOptions()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: VwdOption[]) => {
        this.calcMethodOpt = result;
      }, (e: Error) => {
        console.error('Bond - Calcualtor - Widget - SettingsBox - getBondCalculationMethodeOptions', e);
      });

    this.settingsService.getBondDayCountConventionOptions()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: VwdOption[]) => {
        this.dayConventionOpt = result;
      }, (e: Error) => {
        console.error('Bond - Calcualtor - Widget - SettingsBox - getBondDayCountConventionOptions', e);
      });


    this.lastCouponDateopt.push(new VwdOption(
      moment().add(2, 'years').format('DD.MM.YYYY'),
      new Date(moment().add(2, 'years').format('YYYY-MM-DD'))
    ));
  }

  @Input() set settingsOpt(value: SettingsBox) {
    if (value) {
      this._settingsOpt = value;
      if (value.isDefault) {
        this.twoButActive = false;
        this.threeButActive = false;
      }
      this.changeFrequency(this._settingsOpt.couponFrequency);
    }
  }

  get settingsOpt(): SettingsBox {
    return this._settingsOpt;
  }

  changeFrequency(value: number) {
    this._settingsOpt.couponFrequency = value;

    if (this.checkErrors()) {
      this._settingsOpt.lastCouponDateOptionList = [new VwdOption('', '')];
      this._settingsOpt.lastCouponDate = null;
    } else {

      let option1: VwdOption = null;
      let option2: VwdOption = null;

      const lastCouponDate = new Date(moment(this._settingsOpt.firstCouponDate).format('YYYY-MM-DD'));
      const issueDate = new Date(moment(this._settingsOpt.issueDate).format('YYYY-MM-DD'));
      const monthDifferent = moment(lastCouponDate).diff(moment(issueDate), 'months', true);
      const month = lastCouponDate.getMonth();

      if (value === 1) {

        if (monthDifferent > 11) {

          option1 = new VwdOption(
            moment(lastCouponDate).format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(12, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(12, 'months').format('YYYY-MM-DD')));
        } else {
          option1 = new VwdOption(
            moment(lastCouponDate).add(12, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(12, 'months').format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(24, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(24, 'months').format('YYYY-MM-DD')));
        }

        this._settingsOpt.lastCouponDateOptionList = [option1, option2];
        this._settingsOpt.lastCouponDate = option2.value;
      }


      if (value === 2) {

        if (monthDifferent > 11) {

          option1 = new VwdOption(
            moment(lastCouponDate).add(12, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(12, 'months').format('DD.MM.YYYY')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(18, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(18, 'months').format('YYYY-MM-DD')));
        } else {
          option1 = new VwdOption(
            moment(lastCouponDate).add(24, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(24, 'months').format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(30, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(30, 'months').format('YYYY-MM-DD')));
        }

        this._settingsOpt.lastCouponDateOptionList = [option1, option2];
        this._settingsOpt.lastCouponDate = option2.value;

      }

      if (value === 3) {

        option1 = new VwdOption(
          moment(lastCouponDate).add(28, 'months').format('DD.MM.YYYY'),
          new Date(moment(lastCouponDate).add(28, 'months').format('YYYY-MM-DD')));

        if (month < 5) {
          option2 = new VwdOption(
            moment(lastCouponDate).add(32, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(32, 'months').format('YYYY-MM-DD')));
        } else {
          option2 = new VwdOption(
            moment(lastCouponDate).add(24, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(24, 'months').format('YYYY-MM-DD')));
        }

        this._settingsOpt.lastCouponDateOptionList = [option1, option2];
        this._settingsOpt.lastCouponDate = option1.value;
      }

      if (value === 4) {

        if (month > -1 && month < 3) {
          option1 = new VwdOption(
            moment(lastCouponDate).add(30, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(30, 'months').format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(33, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(33, 'months').format('YYYY-MM-DD')));

        } else if (month > 2 && month < 6) {
          option1 = new VwdOption(
            moment(lastCouponDate).add(27, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(27, 'months').format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(30, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(30, 'months').format('YYYY-MM-DD')));

        } else if (month > 5 && month < 9) {
          option1 = new VwdOption(
            moment(lastCouponDate).add(24, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(24, 'months').format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(27, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(27, 'months').format('YYYY-MM-DD')));

        } else {

          option1 = new VwdOption(
            moment(lastCouponDate).add(21, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(21, 'months').format('YYYY-MM-DD')));

          option2 = new VwdOption(
            moment(lastCouponDate).add(24, 'months').format('DD.MM.YYYY'),
            new Date(moment(lastCouponDate).add(24, 'months').format('YYYY-MM-DD')));
        }

        this._settingsOpt.lastCouponDateOptionList = [option1, option2];
        this._settingsOpt.lastCouponDate = option2.value;
      }

      if (value === 0) {

        const restMonth = 12 - month;

        option1 = new VwdOption(
          moment(lastCouponDate).add(restMonth + 22, 'months').format('DD.MM.YYYY'),
          new Date(moment(lastCouponDate).add(restMonth + 22, 'months').format('YYYY-MM-DD')));

        option2 = new VwdOption(moment(lastCouponDate).add(restMonth + 23, 'months').format('DD.MM.YYYY'),
          new Date(moment(lastCouponDate).add(restMonth + 23, 'months').format('YYYY-MM-DD')));

        this._settingsOpt.lastCouponDateOptionList = [option1, option2];
        this._settingsOpt.lastCouponDate = option2.value;

      }
    }
  }

  private checkErrors() {

    let firstCouponDate;
    let issueDate;
    let error = false;

    if (this._settingsOpt.couponFrequency === 1) {
      firstCouponDate = moment(this._settingsOpt.firstCouponDate).format('YYYY-MM-DD');
      issueDate = moment(this._settingsOpt.issueDate).add(2, 'year').format('YYYY-MM-DD');
    } else if (this._settingsOpt.couponFrequency === 2) {
      firstCouponDate = moment(this._settingsOpt.firstCouponDate).format('YYYY-MM-DD');
      issueDate = moment(this._settingsOpt.issueDate).add(1, 'year').format('YYYY-MM-DD');
    } else if (this._settingsOpt.couponFrequency === 3) {
      firstCouponDate = moment(this._settingsOpt.firstCouponDate).format('YYYY-MM-DD');
      issueDate = moment(this._settingsOpt.issueDate).add(8, 'months').format('YYYY-MM-DD');
    } else if (this._settingsOpt.couponFrequency === 4) {
      firstCouponDate = moment(this._settingsOpt.firstCouponDate).format('YYYY-MM-DD');
      issueDate = moment(this._settingsOpt.issueDate).add(6, 'months').format('YYYY-MM-DD');
    } else {
      firstCouponDate = moment(this._settingsOpt.firstCouponDate).format('YYYY-MM-DD');
      issueDate = moment(this._settingsOpt.issueDate).add(2, 'months').format('YYYY-MM-DD');
    }

    const frequencies = {
      1: this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.FREQUENCY_OPTIONS.OPTION_1'),
      2: this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.FREQUENCY_OPTIONS.OPTION_2'),
      3: this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.FREQUENCY_OPTIONS.OPTION_3'),
      4: this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.FREQUENCY_OPTIONS.OPTION_4'),
      0: this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.FREQUENCY_OPTIONS.OPTION_0')

    };

    if (firstCouponDate > issueDate) {
      error = true;
      this.firstCouponError = true;
      this.handleError.emit(this.firstCouponError);
    //  tslint:disable-next-line:max-line-length
      this.errorMessage = `${this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.TOOLTIP.FIRST_COUPON_DATE_1')} (${frequencies[this._settingsOpt.couponFrequency]}) ${this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.TOOLTIP.FIRST_COUPON_DATE_2')} ${moment(issueDate).add(1, 'day').format('DD.MM.YYYY')} `;
    } else {
      this.firstCouponError = false;
      this.handleError.emit(this.firstCouponError);
    }

    return error;
  }



  calcValueDate(num: number) {

    const date = moment(this._settingsOpt.valueDate);

    if (num === 2) {
      if (this.twoButActive) {
        this.twoButActive = false;
        date.subtract(2, 'days');
      } else {
        this.twoButActive = true;
        date.add(2, 'days');

        if (this.threeButActive) {
          this.threeButActive = false;
          date.subtract(3, 'days');
        }
      }
    }

    if (num === 3) {
      if (this.threeButActive) {
        this.threeButActive = false;
        date.subtract(3, 'days');
      } else {
        this.threeButActive = true;
        date.add(3, 'days');

        if (this.twoButActive) {
          this.twoButActive = false;
          date.subtract(2, 'days');
        }
      }
    }

    this._settingsOpt.valueDate = date.toDate();

  }

  changeValueDate(value: Date) {
    const date = moment(value);

    if (this.twoButActive) {
      date.add(2, 'days');
    } else if (this.threeButActive) {
      date.add(3, 'days');
    }
    this.settingsOpt.valueDate = date.toDate();
  }

  changeDateOpt(value: Date, optName: string) {
    this._settingsOpt[optName] = value;
    if (optName === 'firstCouponDate') {
      this.changeFrequency(this._settingsOpt.couponFrequency);
    }

    if (optName === 'issueDate') {
      this.checkErrors();
    }
  }

  changePilldownOpt(value: string, optName: string) {
    this._settingsOpt[optName] = value;
  }

  changeOption(value: string, optName: string) {
    if (!value) {
      value = '0';
    }
    this._settingsOpt[optName] = this.formattingService.parseFloat(value);
  }

  calculate(): void {
    this.optChanged.emit(this._settingsOpt);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
